import { omit } from "lodash/fp";
import * as React from "react";
import { Diagram } from "./components/Diagram";
import { PanZoom } from "./components/PanZoom";
const containerStyleBase = `
.UserSpecifiedContainer {
  font-family: "Roboto";
  position: "relative";
  width: "100%";
  height: "100%";
  /* To avoid covering up the resize handle (grab area) */
  border-bottom-right-radius: 1em 1em;
  overflow: hidden;
}

.Container {
  width: inherit;
  height: inherit;
  /* To avoid covering up the resize handle (grab area) */
  border-bottom-right-radius: inherit;
  overflow: inherit;
}

/* this is the svg */
.Diagram {
  width: inherit;
  height: inherit;
  overflow: inherit;
  color-interpolation: auto;
  image-rendering: auto;
  shape-rendering: auto;
  vector-effect: non-scaling-stroke;
}`;
/**
 * Kaavio component.
 * This is the highest component in Kaavio. All states are handled here and passed down as props to other components.
 *
 * You may pass an onReady(kaavio) function to this. This will be called with the Kaavio reference when everything is
 * rendered. You can access the manipulation API via kaavio.manipulator
 */
export class Kaavio extends React.Component {
    constructor(props) {
        super(props);
        /*
        componentWillReceiveProps(nextProps) {
        }
          //*/
        this.addStyle = (styles) => {
            var styleEl = document.createElement("style");
            styleEl.innerHTML = styles.join("\n");
            // Append style element to head
            document.head.appendChild(styleEl);
        };
        this.onPanZoomReady = panZoom => {
            // Fire the onReady function with a reference to Kaavio
            const { onReady } = this.props;
            !!onReady && onReady(this);
        };
        this.handleClick = e => {
            const { onEntityClick } = this.props;
            const entity = e.entity;
            if (onEntityClick && entity)
                onEntityClick(entity);
        };
        const { theme, opacities, highlights } = this.props;
        const { containerStyle: containerStyleCustom } = theme;
        // TODO don't just keep adding!
        this.addStyle([containerStyleBase, containerStyleCustom]);
        this.state = {
            diagramRef: null
        };
    }
    render() {
        const { entitiesById, pathway, zoomedEntities, pannedEntities, zoomLevel, panCoordinates, onPanZoomChange, theme, showPanZoomControls = true, panZoomLocked = false, highlights, opacities
        /*
        zoomedEntities,
        pannedEntities,
        zoomLevel,
        panCoordinates,
        showPanZoomControls = true,
        panZoomLocked = false
              //*/
         } = this.props;
        /*
        const {
          entitiesById,
          pathway,
          zoomedEntities,
          pannedEntities,
          zoomLevel,
          panCoordinates,
          onPanZoomChange,
          theme,
          showPanZoomControls = true,
          panZoomLocked = false,
          highlights,
    
          opacities
    //      zoomedEntities,
    //      pannedEntities,
    //      zoomLevel,
    //      panCoordinates,
    //      showPanZoomControls = true,
    //      panZoomLocked = false
        } = this.state;
          //*/
        // TODO: Don't use refs!
        // Accessing the diagram ref from the state is a little bit of a hack to get panZoom working.
        // Consider refactoring the panZoom to be truly Reactive and not use refs
        return (React.createElement("div", { id: `kaavio-container-for-${pathway.id}`, className: "Container" },
            React.createElement(Diagram, { ref: diagram => !this.state.diagramRef && this.setState({ diagramRef: diagram }), entitiesById: entitiesById, opacities: opacities, highlights: highlights, pathway: pathway, handleClick: this.handleClick, theme: omit("containerStyle", theme) }),
            React.createElement(PanZoom, { diagram: this.state.diagramRef, zoomLevel: zoomLevel, panCoordinates: panCoordinates, zoomedEntities: zoomedEntities, pannedEntities: pannedEntities, onChange: onPanZoomChange, locked: panZoomLocked, onReady: this.onPanZoomReady, showPanZoomControls: showPanZoomControls })));
    }
}
//# sourceMappingURL=data:application/json;base64,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